export const BuildingSmallIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="27"
    fill="none"
    viewBox="0 0 26 27"
    {...props}>
    <path
      stroke="#455A64"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M13.636 25.5H3.532C2.14 25.5 1 24.384 1 23.016V5.208C1 2.064 3.34.636 6.208 2.04l5.328 2.616c1.152.564 2.1 2.064 2.1 3.336V25.5z"></path>
    <path
      stroke="#455A64"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M25 17.171v4.536c0 2.592-1.2 3.792-3.792 3.792h-7.572V11.604l.564.12 5.4 1.211 2.436.54c1.584.348 2.88 1.165 2.951 3.468.013.072.013.144.013.228zM5.236 9.9H9.4M5.236 14.7H9.4"></path>
  </svg>
);
